"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DarksideIncubationPlant = void 0;
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const MoonExpansion_1 = require("../../moon/MoonExpansion");
const CardRenderer_1 = require("../render/CardRenderer");
const CardRenderDynamicVictoryPoints_1 = require("../render/CardRenderDynamicVictoryPoints");
const Units_1 = require("../../Units");
const MoonCard_1 = require("./MoonCard");
const LogHelper_1 = require("../../LogHelper");
const constants_1 = require("../../constants");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Card_1 = require("../Card");
class DarksideIncubationPlant extends MoonCard_1.MoonCard {
    constructor() {
        super({
            name: CardName_1.CardName.DARKSIDE_INCUBATION_PLANT,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.MOON],
            cost: 11,
            resourceType: ResourceType_1.ResourceType.MICROBE,
            reserveUnits: Units_1.Units.of({ titanium: 1 }),
            metadata: {
                description: {
                    text: 'Spend 1 titanium. 1 VP for every 2 microbes here.',
                    align: 'left',
                },
                cardNumber: 'M45',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action(undefined, (eb) => {
                        eb.empty().startAction.microbes(1).or();
                    }).br;
                    b.action('Add 1 microbe here, or spend 2 microbes to raise the Colony Rate 1 step.', (eb) => {
                        eb.microbes(2).startAction.moonColonyRate();
                    });
                    b.br;
                    b.minus().titanium(1);
                }),
                victoryPoints: CardRenderDynamicVictoryPoints_1.CardRenderDynamicVictoryPoints.microbes(1, 2),
            },
        });
        this.resourceCount = 0;
    }
    ;
    play(player) {
        super.play(player);
        return undefined;
    }
    canAct(player) {
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const trGain = 1;
        if (this.resourceCount >= 2)
            Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'raise Moon colony rate');
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
        }
        return true;
    }
    action(player) {
        if (this.resourceCount < 2) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        const orOptions = new OrOptions_1.OrOptions();
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        MoonExpansion_1.MoonExpansion.ifMoon(player.game, (moonData) => {
            if (!redsAreRuling || (redsAreRuling && player.canAfford(this.reserveUnits.megacredits)) || moonData.colonyRate === constants_1.MAXIMUM_COLONY_RATE) {
                orOptions.options.push(new SelectOption_1.SelectOption('Spend 2 microbes to raise the Colony Rate 1 step', 'Select', () => {
                    player.removeResourceFrom(this, 2);
                    LogHelper_1.LogHelper.logRemoveResource(player, this, 2, 'raise the Colony Rate');
                    MoonExpansion_1.MoonExpansion.raiseColonyRate(player);
                    return undefined;
                }));
            }
        });
        orOptions.options.push(new SelectOption_1.SelectOption('Add 1 microbe to this card', 'Add microbe', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        }));
        if (orOptions.options.length === 1)
            return orOptions.options[0].cb();
        return orOptions;
    }
    getVictoryPoints() {
        return Math.floor(this.resourceCount / 2);
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ moonColonyRateIncrease: 1 });
    }
}
exports.DarksideIncubationPlant = DarksideIncubationPlant;
//# sourceMappingURL=DarksideIncubationPlant.js.map